import { Viewer3D } from './viewer.js'
let viewerInstance
let viewerContainer

const createViewerInstance = () => {
  const containerID = 'viewer3DContainer'
  viewerContainer = document.createElement('div')
  viewerContainer.id = containerID
  viewerContainer.classList.add('viewer3D')
  viewerContainer.style.width = '100%'
  viewerContainer.style.height = '100vh'
  viewerContainer.style.display = 'none'
  viewerContainer.style.overflow = 'hidden'
  const canvas = document.createElement('canvas')
  canvas.classList.add('webgl')
  canvas.style.width = '100%'
  canvas.style.height = '100%'
  canvas.style.display = 'block'
  viewerContainer.appendChild(canvas)
  document.body.prepend(viewerContainer)
  const config = {
    viewerContainer: viewerContainer,
    canvasElement: canvas,
    guiVisible: false,
    orbitControlsEnabled: false,
    mouseEventForCamera: true,
    colorBackground: "#000000",
    color1: "#5500ff",
    color2: "#ffb4fb",
  }
  viewerInstance = new Viewer3D(config)
  // viewerInstance.updateRenderAspect()
  // viewerInstance.updateAspect()
  viewerInstance.handleResize()
  document.body.removeChild(viewerContainer)
  viewerContainer.style.display = 'block'
  viewerContainer.addEventListener("change", () => {
    viewerInstance.handleResize()
  });
}

const loadJS = src => {
  return new Promise((resolve, reject) => {
    let scriptElement = document.createElement('script')
    const id = new Date().getTime().toString()
    scriptElement.id = id
    scriptElement.src = src
    const firstScriptTag = document.getElementsByTagName('script')[0]
    scriptElement.addEventListener('load', resolve)
    firstScriptTag.parentNode.insertBefore(scriptElement, firstScriptTag)
  })
}

const initViewer = async () => {
  if (!viewerInstance) {
    // const src = '/viewer3d.js?v=' + version
    // await loadJS(src)
    createViewerInstance()
  }
}

export {
  viewerInstance,
  viewerContainer,
  loadJS,
  initViewer
}
